import { Link } from 'react-router-dom';

const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Why Valanti Labs', to: '/why-valanti-labs' },
      { label: 'How It Works', to: '/how-it-works' },
      { label: 'Technology', to: '/technology' },
    ],
  },
  {
    title: 'Audiences',
    links: [
      { label: 'For Individuals', to: '/for-individuals' },
      { label: 'For Professionals', to: '/for-professionals' },
      { label: 'Partners', to: '/partners' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Research', to: '/research' },
      { label: 'Early Access', to: '/early-access' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Legal & Support',
    links: [
      { label: 'Support', to: '/support' },
      { label: 'Privacy', to: '/privacy' },
      { label: 'Terms', to: '/terms' },
      { label: 'Account Deletion', to: '/support/delete-account' },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t hairline bg-vl-bg2">
      <div className="vl-container py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-vl-ink text-vl-bg font-serif-display text-lg">
                V
              </span>
              <span className="font-serif-display text-xl text-vl-ink">Valanti Labs</span>
            </div>
            <p className="mt-5 text-sm text-vl-ink/70 max-w-sm leading-relaxed">
              AI-powered movement analysis from a smartphone camera. Designed to help people better understand how they
              move — through recovery, rehabilitation, and everyday strength.
            </p>
            <p className="mt-6 mono-label text-vl-ink/55">
              Valanti Labs Pty Ltd · ABN 54 692 520 497 · Australia
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="mono-label text-vl-ink/55 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                      className="text-sm text-vl-ink/75 hover:text-vl-ink transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 pt-8 border-t hairline flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-vl-ink/55">
            © {new Date().getFullYear()} Valanti Labs Pty Ltd. All rights reserved.
          </p>
          <p className="text-xs text-vl-ink/55 max-w-xl">
            Valanti Labs is not a substitute for a doctor, physiotherapist, or other qualified professional. The
            application is in pre-release preparation.
          </p>
        </div>
      </div>
    </footer>
  );
}
